/*
 * Cart-page upsell add handler.
 *
 * Why this exists instead of using product-form.js:
 *   On the cart page, product-form.js resolves this.cart to the cart-notification
 *   element (header.liquid renders it on every page), so an add swaps the
 *   notification's sections and pops a notification over a stale cart. It also
 *   only dispatches cart:updated on its non-modal path.
 *   Adding that dispatch would newly fire the live free-gift engine
 *   (auto-add-offer.js) and promo threshold tracking (promo-popup.js) on every
 *   modal quick-add site-wide, so product-form.js is deliberately left alone.
 *
 * Section swap logic is adapted from assets/auto-add-offer.js:146-205.
 */
(function () {
  var WRAPPER_ID = 'cart-upsell';

  function sectionsToRequest() {
    var list = [];
    var itemsEl = document.getElementById('main-cart-items');
    if (itemsEl) list.push({ id: 'main-cart-items', section: itemsEl.dataset.id, selector: '.js-contents' });
    var footerEl = document.getElementById('main-cart-footer');
    if (footerEl) {
      list.push({ id: 'main-cart-footer', section: footerEl.dataset.id, selector: '.js-contents' });
      list.push({ id: WRAPPER_ID, section: footerEl.dataset.id, selector: '.cart__collection' });
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }

  function applySections(rendered, list) {
    list.forEach(function (s) {
      var key = s.section || s.id;
      var html = rendered[key];
      var el = document.getElementById(s.id);
      if (!html || !el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = s.selector ? doc.querySelector(s.selector) : doc.body;
      var target = (s.selector && el.querySelector(s.selector)) || el;
      if (node) target.innerHTML = node.innerHTML;
    });
  }

  // Mirrors product-form.js: the first <span> in the button is the label, and
  // .sold-out-message (inside the button) replaces it while an error is shown.
  function clearError(form, button) {
    var old = form.querySelector('.cart-upsell-error');
    if (old) old.remove();
    var sold = button && button.querySelector('.sold-out-message');
    if (sold && sold.dataset.upsellError) {
      delete sold.dataset.upsellError;
      sold.classList.add('hidden');
      var label = button.querySelector('span');
      if (label && label !== sold) label.classList.remove('hidden');
    }
  }

  function showError(form, button, message) {
    // Fallback uses the theme's translated cart error (layout/theme.liquid sets window.cartStrings),
    // so it follows the storefront language; Shopify's own error descriptions are already localised.
    var fallback = (window.cartStrings && window.cartStrings.error) || 'Sorry, this item could not be added.';
    var text = message || fallback;
    var sold = button && button.querySelector('.sold-out-message');
    if (sold) {
      sold.textContent = text;
      sold.dataset.upsellError = 'true';
      var label = button.querySelector('span');
      if (label && label !== sold) label.classList.add('hidden');
      sold.classList.remove('hidden');
      return;
    }
    var node = document.createElement('p');
    node.className = 'cart-upsell-error';
    node.setAttribute('role', 'alert');
    node.textContent = text;
    if (button && button.parentNode) button.parentNode.insertBefore(node, button.nextSibling);
    else form.appendChild(node);
  }

  // Same loading state product-form.js uses: base.css hides the label and centres the
  // button's .loading-overlay__spinner while .loading is set.
  function setLoading(button, on) {
    if (!button) return;
    button.classList.toggle('loading', on);
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  function addVariant(variantId, quantity, button, form) {
    var sections = sectionsToRequest();
    if (button) button.setAttribute('aria-disabled', 'true');
    setLoading(button, true);
    clearError(form, button);
    var added = false;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1,
        sections: sections.map(function (s) { return s.section || s.id; }),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          console.error('CartUpsell add failed', res.description || res.message);
          showError(form, button, res.description || res.message);
          return null;
        }
        added = true;
        if (res && res.sections) applySections(res.sections, sections);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        // cart.js (<cart-items>) remembers the item count from its own last change and shows
        // "You can only add N of this item" when a change leaves the count unchanged. It doesn't
        // see adds made here, so sync it, or removing this item later shows that error falsely.
        var cartItems = document.querySelector('cart-items');
        if (cartItems && 'currentItemCount' in cartItems) cartItems.currentItemCount = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (err) {
        console.error('CartUpsell add error', err);
        if (!added) showError(form, button, null);
      })
      .then(function () {
        // On success the swap has usually replaced this button already; this covers failures.
        setLoading(button, false);
        if (button) button.removeAttribute('aria-disabled');
      });
  }

  /*
   * Intercept submits from the one-click add forms inside the upsell wrapper.
   * Capture phase on document, so this runs before <product-form>'s own handler
   * and stopPropagation keeps that handler (and its cart notification) out of it.
   */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper || !wrapper.contains(form)) return;

    // form.elements includes form="..."-linked controls AND disabled controls
    // (the real variant input ships disabled until product-form.js enables it).
    var idField = form.elements && form.elements.namedItem('id');
    var variantId = idField && idField.value;
    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;

    var qtyField = form.elements.namedItem('quantity');
    var quantity = parseInt(qtyField && qtyField.value, 10);
    if (!quantity || quantity < 1) quantity = 1;

    addVariant(variantId, quantity, button, form);
  }, true);
})();
